require('./modifyLimitStep2.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { isEmpty } = require('lodash');

// @ actions
const revolvingActions = require('actions/cardRevolvingDocuments');
const cardChangePaymentMethodActions = require('actions/cardChangePaymentMethod');
// @ constants
const { CARD_DECREASE_LIMIT_ID, CARD_INCREASE_LIMIT_ID } = require('constants/operationTypes');
const { CARD_MODIFY_LIMIT_DECREASE, CARD_PAYMENT_METHOD_UNIQUE, CARD_PAYMENT_METHOD_FIXED, CARD_PAYMENT_METHOD_VARIABLE, FIRST_STEP, SECOND_STEP } = require('constants/index');
const { DIAMOND_PACK_PRODUCT_NAME, PREMIUM_PACK_PRODUCT_NAME } = require('constants/cardsPrecontractualMailInfo');
//@commons
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ components
const CardModifyLimitInformativeSection = require('components/cards/cardModifyLimit/cardModifyLimitInformativeSection/cardModifyLimitInformativeSection');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const CardLegalViewerModal = require('components/cards/cardLegalViewerModal/cardLegalViewerModal');
const ContactCenterValidationCards = require('components/hire/contactCenterValidationCards/contactCenterValidationCards');
const WebappRender = require('components/conditionalRender/webappRender');
// @ utilities
const { formatText } = require('core/i18n').i18n;
const { nonNumericFilter } = require('utilities/stringHelper');
const { getCardType } = require('utilities/cardsHelper');
const { validRevolvingCardType } = require('utilities/APIParsingHelper');

class ModifyLimitStep2 extends React.Component {
    constructor(props) {
        super(props);
        let precontractualMailProductInfo = {
            producto: props.immCard.getIn(['product', 'type']),
            standard: props.immCard.getIn(['product', 'standard']),
            subproducto: props.immCard.getIn(['product', 'subtype']),
        };

        if (props.immCard.get('isDiamond')) {
            precontractualMailProductInfo.productName = DIAMOND_PACK_PRODUCT_NAME;
        } else if (props.immCard.get('isPremium')) {
            precontractualMailProductInfo.productName = PREMIUM_PACK_PRODUCT_NAME;
        }

        this.state = {
            precontractualMailProductInfo,
            signatureSectionRevolving: null,
        }
    }

    componentDidMount() {
        const { showIneAndRevolving, immCard } = this.props;
        if (showIneAndRevolving) {
            const cardId = immCard.get('cardId')
            this.props.requestPaymentMethodInfo(cardId);
        }
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.immCardModifyLimit.getIn(['steps', SECOND_STEP]).get('agreementChecked') !==
            this.props.immCardModifyLimit.getIn(['steps', SECOND_STEP]).get('agreementChecked')) &&
            this.props.immCardModifyLimit.getIn(['steps', SECOND_STEP]).get('agreementChecked')) {
            this.setState({ signatureSectionRevolving: this.buildSignatureSection() });
        }
    }

    getCalculationType = (methodSelected) => {
        return methodSelected === CARD_PAYMENT_METHOD_FIXED
            ? 0 : methodSelected === CARD_PAYMENT_METHOD_VARIABLE
                ? 1 : null
    }

    getCardData = (creditType, type) => {
        const {
            immGlobalVariables,
        } = this.props;

        const tintaeValues = {
            'OPEN_CREDIT_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', type]),
            'DIAMOND_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', type]),
            'PREMIUM_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', type]),
            'VIAT_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', type]),
        };

        return tintaeValues[creditType];
    }

    buildSignatureSection = () => {
        const { immCard, immCardModifyLimit } = this.props;
        const immStepOne = immCardModifyLimit.getIn(['steps', FIRST_STEP]);
        const tentativeLimit = immStepOne.get('tentativeLimit');
        const currency = immStepOne.get('currency');
        const params = {};
        let operationType;

        if (immCardModifyLimit.get('operationType') === CARD_MODIFY_LIMIT_DECREASE) {
            params.ammount = tentativeLimit;
            params.currency = currency;
            params.pan = nonNumericFilter(immCard.get('number'));
            operationType = CARD_DECREASE_LIMIT_ID;
        } else {
            params.pan = nonNumericFilter(immCard.get('number'));
            operationType = CARD_INCREASE_LIMIT_ID;
        }
        return (
            <section className="modify-limit-step-two__content">
                <SignaturePattern
                    operationType={operationType}
                    operationParams={params}
                />
            </section>
        )
    }

    getAfiInfo = (methodSelected) => {
        const { immFeatureFlags } = this.props;
        const { precontractualMailProductInfo } = this.state;
        const isRevolvingDocumentVisible = immFeatureFlags.get('revolving_v2_ine') && validRevolvingCardType(precontractualMailProductInfo.producto, precontractualMailProductInfo.subproducto)
            ? validRevolvingCardType(precontractualMailProductInfo.producto, precontractualMailProductInfo.subproducto)
            : methodSelected !== CARD_PAYMENT_METHOD_UNIQUE;

        if (isRevolvingDocumentVisible) {
            const { immCard, setInneParams, setAFIParams, immCardChangePaymentMethod } = this.props;
            const cardType = getCardType(immCard);
            const tin = this.getCardData(cardType, 'aplazado_tin');
            const tae = this.getCardData(cardType, 'aplazado_tae');
            setInneParams({
                tin,
                tae
            });
            const interestRate = Number(tin.replace('%', '').replace(',', '.')) / 100;
            const calculationType = this.getCalculationType(methodSelected);
            const paymentValueParamName = calculationType === 0 ? 'FixedPaymentAmount' : 'PercentagePaymentRate';
            let paymentValue = immCardChangePaymentMethod.getIn(['steps', FIRST_STEP, 'installments']);
            paymentValue = calculationType === 1 ? paymentValue / 100 : paymentValue;

            setAFIParams({
                interestRate,
                calculationType,
                typePayment: paymentValueParamName,
                valuePayment: paymentValue,
            });
        }
    }

    buildContactCenterRevolvingProcess = (methodSelected, agreementChecked, amount) => {
        this.getAfiInfo(methodSelected);
        const { handleAgreementCheckboxChange, immCardModifyLimit, showIneAndRevolving, contractName } = this.props;
        const { precontractualMailProductInfo, signatureSectionRevolving } = this.state;
        const showRevolvingDocument = methodSelected !== CARD_PAYMENT_METHOD_UNIQUE;
        const immSteps = immCardModifyLimit.get('steps');
        const agreementErrorMsg = formatText('revolvingProcessDocuments-revolvingProcessDocuments_checkboxErrorMsgCC');
        const sendMailParams = {
            type: precontractualMailProductInfo.producto,
            subType: precontractualMailProductInfo.subproducto,
            standar: precontractualMailProductInfo.standard,
        };
        return (
            <React.Fragment>
                <ContactCenterValidationCards
                    agreementErrorMsg={agreementErrorMsg}
                    amount={amount}
                    contractName={contractName}
                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                    immStep={immSteps.get(1)}
                    isContractingProcess={false}
                    sendMailParams={sendMailParams}
                    showIneAndRevolving={showIneAndRevolving}
                    showRevolvingDocument={showRevolvingDocument}
                    precontractualMailProductInfo={precontractualMailProductInfo}
                />
                {agreementChecked && <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />}
                {agreementChecked && signatureSectionRevolving}
            </React.Fragment>
        )
    }

    buildRevolvingProcess = (methodSelected, agreementChecked, amount) => {
        this.getAfiInfo(methodSelected);
        const { handleAgreementCheckboxChange } = this.props;
        const { precontractualMailProductInfo, signatureSectionRevolving } = this.state;
        const showRevolvingDocument = methodSelected !== CARD_PAYMENT_METHOD_UNIQUE;

        return (
            <React.Fragment>
                <CardLegalViewerModal
                    amount={amount}
                    agreeCheckboxRevol={agreementChecked}
                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                    isContractingProcess={false}
                    precontractualMailProductInfo={precontractualMailProductInfo}
                    showRevolvingDocument={showRevolvingDocument}
                />
                {agreementChecked && signatureSectionRevolving}
            </React.Fragment>
        )
    }

    buildRevolvingComponents = (agreementChecked, amount) => {
        const { immCardChangePaymentMethod } = this.props;
        const methodSelected = immCardChangePaymentMethod.getIn(['steps', FIRST_STEP, 'method']);

        if (isEmpty(methodSelected)) {
            return (<LoadingSection />)
        } else {
            return (__CONTACT_CENTER__ ?
                this.buildContactCenterRevolvingProcess(methodSelected, agreementChecked, amount)
                :
                this.buildRevolvingProcess(methodSelected, agreementChecked, amount)
            )
        }
    }

    render() {
        const { immCard, immCardModifyLimit, showIneAndRevolving } = this.props;
        const immStepOne = immCardModifyLimit.getIn(['steps', FIRST_STEP]);
        const immStepTwo = immCardModifyLimit.getIn(['steps', SECOND_STEP]);
        const isForRevolvingProcess = immCard.get('isForRevolvingProcess');
        const tentativeLimit = immStepOne.get('tentativeLimit');
        const currency = immStepOne.get('currency');
        const agreementChecked = immStepTwo.get('agreementChecked');
        let operativeName

        if (immCardModifyLimit.get('operationType') === CARD_MODIFY_LIMIT_DECREASE) {
            operativeName = formatText('operatives-decreaseCardLimit');
        } else {
            operativeName = formatText('operatives-increaseCardLimit');
        }
        const newLimit = {
            amount: tentativeLimit,
            currency
        };

        return (
            <article className="modify-limit-step-two">
                <CardModifyLimitInformativeSection
                    operativeName={__CONTACT_CENTER__ ? operativeName : undefined}
                    immCard={immCard}
                    newLimit={newLimit}
                    titleKey="cardModifyLimitInformativeSection-stepTwoTitle"
                />
                <ContactCenterRender>
                    {showIneAndRevolving && isForRevolvingProcess ? (
                        this.buildRevolvingComponents(agreementChecked, tentativeLimit)
                    ) : (
                        <ConfirmationScript
                            confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}
                        />
                    )}
                </ContactCenterRender>
                <WebappRender>
                    {showIneAndRevolving && isForRevolvingProcess ?
                        this.buildRevolvingComponents(agreementChecked, tentativeLimit)
                        :
                        this.buildSignatureSection()
                    }
                </WebappRender>

            </article>
        );
    }
}

ModifyLimitStep2.propTypes = {
    contractName: PropTypes.string,
    handleAgreementCheckboxChange: PropTypes.func,
    immCardChangePaymentMethod: PropTypes.object,
    immCardModifyLimit: PropTypes.object,
    immCard: PropTypes.object,
    immGlobalVariables: PropTypes.object,
    requestPaymentMethodInfo: PropTypes.func,
    showIneAndRevolving: PropTypes.bool,
    setAFIParams: PropTypes.func,
    setInneParams: PropTypes.func,
    immFeatureFlags: PropTypes.object,
};

module.exports = connect(
    state => ({
        immCardChangePaymentMethod: state.cardChangePaymentMethod,
        immGlobalVariables: state.globalVariables,
        immFeatureFlags: state.flagBasedFeatures,
    }), {
    requestPaymentMethodInfo: cardChangePaymentMethodActions.requestPaymentMethodInfo,
    setAFIParams: revolvingActions.setAFIParams,
    setInneParams: revolvingActions.setInneParams
}
)(ModifyLimitStep2);